import { PilotId } from '~/eds/src/types/PilotId';
import { SavedSearch } from '~/features/search/types/search';
import { pilotV3 } from '~/services/serviceInstances';

import { JsonApiGetResponse } from '../../ApiTypes';
import { SavedSearchAttributes, SavedSearchMeta } from './types';
import { mapSavedSearchResponseToSavedSearch } from './utils';

type Response = JsonApiGetResponse<
  'saved-search',
  SavedSearchAttributes,
  void,
  SavedSearchMeta
>;
export const getSavedSearch = async (id: PilotId): Promise<SavedSearch> => {
  const response: Response = await pilotV3.get(`/saved-search/${id}/`);

  return mapSavedSearchResponseToSavedSearch(response);
};
